import { createAction, props } from '@ngrx/store';

export enum SecurityTypes {
  available = 'security/available',
}

export const available = createAction(SecurityTypes.available, props<{ available: boolean }>());
